import React, { useState } from 'react'
import { DocumentListItem } from '../../types'
import { STATUS_LABELS, STATUS_COLORS, STATUS_INDICATORS } from './constants'
import { listStyles } from './styles'
import Spinner from '../Spinner'

interface Props {
  documents: DocumentListItem[]
  onSelectDocument: (doc: DocumentListItem) => void
  selectedId?: string
}

const DocumentList: React.FC<Props> = ({ documents, onSelectDocument, selectedId }) => {
  const [hoveredId, setHoveredId] = useState<string | null>(null)

  if (documents.length === 0) {
    return (
      <div style={listStyles.container}>
        <table style={listStyles.table}>
          <thead>
            <tr style={listStyles.header}>
              <th style={listStyles.headerCell}>Status</th>
              <th style={listStyles.headerCell}>Requisition</th>
              <th style={listStyles.headerCell}>Patient</th>
            </tr>
          </thead>
        </table>
        <div style={listStyles.empty}>
          No documents uploaded yet. Click{' '}
          <span style={{ color: '#c0392b', fontWeight: 700 }}>
            "Upload Document"
          </span>{' '}
          to begin.
        </div>
      </div>
    )
  }

  return (
    <div style={listStyles.container}>
      <table style={listStyles.table}>
        <thead>
          <tr style={listStyles.header}>
            <th style={listStyles.headerCell}>Status</th>
            <th style={listStyles.headerCell}>Requisition</th>
            <th style={listStyles.headerCell}>Patient</th>
          </tr>
        </thead>
        <tbody>
          {documents.map((doc) => {
            const isSelected = doc.id === selectedId
            const isHovered = doc.id === hoveredId
            const isClickable = doc.status !== 'uploading'

            return (
              <tr
                key={doc.id}
                style={{
                  ...listStyles.row,
                  backgroundColor: isSelected ? '#fdf0f0' : isHovered ? '#f9f9f9' : 'white',
                  cursor: isClickable ? 'pointer' : 'default',
                  opacity: isClickable ? 1 : 0.8,
                }}
                onClick={() => isClickable && onSelectDocument(doc)}
                onMouseEnter={() => setHoveredId(doc.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                <td style={listStyles.cell}>
                  <span style={{ color: STATUS_COLORS[doc.status] }}>
                    {doc.status === 'uploading'
                      ? <><Spinner />{STATUS_LABELS[doc.status]}</>
                      : <>{STATUS_INDICATORS[doc.status]} {STATUS_LABELS[doc.status]}</>
                    }
                  </span>
                </td>
                <td style={listStyles.cell}>{doc.filename}</td>
                <td style={listStyles.cell}>
                  {doc.status === 'uploading' ? '—' : doc.patientName ?? '—'}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default DocumentList
